import React from "react";
import { Col, Container, Row, Image, Button } from "react-bootstrap";

export const ExtendKnowledge = () => {
  return (
    <Container fluid style={{ background: "#F7F7F7" }}>
      <Container>
        <div className="bg_white text-left">
          <div>
            <p className="text-2xl p-2" style={{ color: "#6A489C" }}>
              Latest News & trend
            </p>
          </div>
          <h1 className="text-5xl text-black robot">Extend Knowledge</h1>
        </div>
      </Container>
      <Container>
        <Row>
          <Col lg="4">
            <div className="p-3">
              <div
                style={{
                  background: "white",
                  border: "1px solid #C1C1C1",
                  borderRadius: "30px",
                }}
              >
                <Image src={require("../../../assets/know1.png")} />

                <p style={{ float: "right" }}>30 May 2022</p>

                <div className="p-2">
                  <h2
                    className="text-4xl font-bold mt-3 robot"
                    style={{ color: "#6A489C" }}
                  >
                    Post Title
                  </h2>
                  <p className="py-3">
                    A simply dummy text of the printing and typesetting
                    industry. Lorem Ipsum has been the industry's standard dummy
                    text ever since the 1500s, only five centuries,
                  </p>
                  <div className="webkit">
                    <Button
                      className="text-lg"
                      style={{
                        background: "none",
                        border: "none",
                        color: "#6A489C",
                      }}
                    >
                      Read More
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg="4">
            <div className="p-3">
              <div
                style={{
                  background: "white",
                  border: "1px solid #C1C1C1",
                  borderRadius: "30px",
                }}
              >
                <Image src={require("../../../assets/know2.png")} />

                <p style={{ float: "right" }}>30 May 2022</p>

                <div className="p-2">
                  <h2
                    className="text-4xl font-bold mt-3 robot"
                    style={{ color: "#6A489C" }}
                  >
                    Post Title
                  </h2>
                  <p className="py-3">
                    A simply dummy text of the printing and typesetting
                    industry. Lorem Ipsum has been the industry's standard dummy
                    text ever since the 1500s, only five centuries,
                  </p>
                  <div className="webkit">
                    <Button
                      className="text-lg"
                      style={{
                        background: "none",
                        border: "none",
                        color: "#6A489C",
                      }}
                    >
                      Read More
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg="4">
            <div className="p-3">
              <div
                style={{
                  background: "white",
                  border: "1px solid #C1C1C1",
                  borderRadius: "30px",
                }}
              >
                <Image src={require("../../../assets/know3.png")} />

                <p style={{ float: "right" }}>30 May 2022</p>

                <div className="p-2">
                  <h2
                    className="text-4xl font-bold mt-3 robot"
                    style={{ color: "#6A489C" }}
                  >
                    Post Title
                  </h2>
                  <p className="py-3">
                    A simply dummy text of the printing and typesetting
                    industry. Lorem Ipsum has been the industry's standard dummy
                    text ever since the 1500s, only five centuries,
                  </p>
                  <div className="webkit">
                    <Button
                      className="text-lg"
                      style={{
                        background: "none",
                        border: "none",
                        color: "#6A489C",
                      }}
                    >
                      Read More
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg="4">
            <div className="p-3">
              <div
                style={{
                  background: "white",
                  border: "1px solid #C1C1C1",
                  borderRadius: "30px",
                }}
              >
                <Image src={require("../../../assets/know4.png")} />

                <p style={{ float: "right" }}>30 May 2022</p>

                <div className="p-2">
                  <h2
                    className="text-4xl font-bold mt-3 robot"
                    style={{ color: "#6A489C" }}
                  >
                    Post Title
                  </h2>
                  <p className="py-3">
                    A simply dummy text of the printing and typesetting
                    industry. Lorem Ipsum has been the industry's standard dummy
                    text ever since the 1500s, only five centuries,
                  </p>
                  <div className="webkit">
                    <Button
                      className="text-lg"
                      style={{
                        background: "none",
                        border: "none",
                        color: "#6A489C",
                      }}
                    >
                      Read More
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg="4">
            <div className="p-3">
              <div
                style={{
                  background: "white",
                  border: "1px solid #C1C1C1",
                  borderRadius: "30px",
                }}
              >
                <Image src={require("../../../assets/know5.png")} />

                <p style={{ float: "right" }}>30 May 2022</p>

                <div className="p-2">
                  <h2
                    className="text-4xl font-bold mt-3 robot"
                    style={{ color: "#6A489C" }}
                  >
                    Post Title
                  </h2>
                  <p className="py-3">
                    A simply dummy text of the printing and typesetting
                    industry. Lorem Ipsum has been the industry's standard dummy
                    text ever since the 1500s, only five centuries,
                  </p>
                  <div className="webkit">
                    <Button
                      className="text-lg"
                      style={{
                        background: "none",
                        border: "none",
                        color: "#6A489C",
                      }}
                    >
                      Read More
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg="4">
            <div className="p-3">
              <div
                style={{
                  background: "white",
                  border: "1px solid #C1C1C1",
                  borderRadius: "30px",
                }}
              >
                <Image src={require("../../../assets/know6.png")} />

                <p style={{ float: "right" }}>30 May 2022</p>

                <div className="p-2">
                  <h2
                    className="text-4xl font-bold mt-3 robot"
                    style={{ color: "#6A489C" }}
                  >
                    Post Title
                  </h2>
                  <p className="py-3">
                    A simply dummy text of the printing and typesetting
                    industry. Lorem Ipsum has been the industry's standard dummy
                    text ever since the 1500s, only five centuries,
                  </p>
                  <div className="webkit">
                    <Button
                      className="text-lg"
                      style={{
                        background: "none",
                        border: "none",
                        color: "#6A489C",
                      }}
                    >
                      Read More
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
